import Link from "next/link";

// The public footer and its editor share this markup. Controls exist only in the editor.
export default function FooterLinkGroup({ items = [], position, editor, className = "", linkClassName = "" }) {
  return <div>
    <ul className={className}>{items.map((item, index) => <li key={item.id || index} className={editor ? "footer-edit-row" : undefined}>
      {editor ? <>
        <button type="button" className={linkClassName + " footer-edit-label"} onClick={() => editor.edit(position, index)}>{item.label}</button>
        <span className="footer-edit-controls"><button type="button" onClick={() => editor.edit(position, index)}>Edit</button><button type="button" aria-label={"Remove " + item.label} onClick={() => editor.remove(position, index)}>Remove</button></span>
      </> : <Link href={item.href} className={linkClassName}>{item.label}</Link>}
      {item.children?.length > 0 && <FooterLinkGroup items={item.children} position={position} className={className} linkClassName={linkClassName} />}
    </li>)}</ul>
    {editor && <button type="button" className="footer-add-link" onClick={() => editor.edit(position, -1)}>+ Add link</button>}
  </div>;
}
